// eslint-disable-next-line simple-import-sort/imports
import { motion, useAnimation, useInView } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { styled } from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  z-index: 1;
`;

const AnimatedMoveTitle = ({
  children,
  defaultTitle,
  width = 'fit-content',
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start('visible');
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [isInView]);

  return (
    <Wrapper ref={ref} style={{ width }}>
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate={mainControls}
        transition={{ duration: 0.2, delay: 0.35 }}
        style={{ zIndex: 3 }}
      >
        {children}
      </motion.div>
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate={mainControls}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          borderRadius: ' 33px',
          background: `linear-gradient(90deg, ${defaultTitle ? 'rgba(219, 237, 255, 0.4)' : '#DBEDFF'} 0%, rgba(255, 255, 255, 0.00) 0%)`,
          zIndex: -1,
        }}
      ></motion.div>
    </Wrapper>
  );
};

AnimatedMoveTitle.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.string,
  defaultTitle: PropTypes.bool,
};

export default AnimatedMoveTitle;
